const getters = {
  sidebar: state => state.app.sidebar,
  name: state => state.user.name,
  userName: state => state.user.userName,
  userId: state => state.user.userId,
  roles: state => state.user.roles,
  businessModes: state => state.user.businessModes,
  permissions: state => state.user.permissions,
  userTeachClassList: state => state.user.userTeachClassList,
  // 是否有考试分析权限
  hasExamAnalysis: state => {
    let {name} = state.user
    // console.log('userTeachClassList: ', userTeachClassList);
    const userNamePermission = ['卢旭怡', '刘志茜', '许海珠']
    return userNamePermission.includes(name)
  },
  experienceFunctionsBlackList: state => state.user.experienceFunctionsBlackList,
  teacherRoleIds: state => state.user.teacherRoleIds,

  aiTutorPermissions: state => state.user.aiTutorPermissions,

  permissionRouters: state => state.permission.routers,
  addRouters: state => state.permission.addRouters,
  experiment:state => state.experiment,
  teacher: state => state.user.teacher,
  studentAnalysisSearchParams: state => state.studentAnalysis.seachParams,
  studentAnalysisPublicTime: state => state.studentAnalysis.publicTime,

  // 授课store
  toolResourceFileActive: state => state.teaching.toolResourceFileActive,
  toolItemZIndex: state => state.teaching.toolItemZIndex,
  isFullScreen: state => state.teaching.isFullScreen,
  imgList: state => state.teaching.imgList,
  isPreview: state => state.teaching.isPreview,
  isMultiPhotoPreview: state => state.teaching.isMultiPhotoPreview,
  chapter: state => state.teaching.chapter,
  taskPanelFull: state => state.teaching.taskPanelFull,
  qrzRankFull: state => state.teaching.qrzRankFull,
}
export default getters
